import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListDistributorComponent } from './list-distributor/list-distributor.component';
import { CreateDistributorComponent } from './create-distributor/create-distributor.component';
import { UpdateDistributorComponent } from './update-distributor/update-distributor.component';
import { permissionGuard } from 'src/app/shared/guards/permission/permission.guard';
import { Permission } from 'src/app/shared/models/permission/permission-dto';
import { TestSendNewsletterEmailComponent } from './test-send-newsletter-email/test-send-newsletter-email.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [permissionGuard],
    data: { permission: Permission.LIST_DISTRIBUTOR },
    component: ListDistributorComponent
  },
  {
    path: 'create',
    canActivate: [permissionGuard],
    data: { permission: Permission.CREATE_DISTRIBUTOR },
    component: CreateDistributorComponent
  },
  {
    path: ':id/update',
    canActivate: [permissionGuard],
    data: { permission: Permission.UPDATE_DISTRIBUTOR },
    component: UpdateDistributorComponent
  },
  {
    path: 'test-send-newsletter-email',
    canActivate: [permissionGuard],
    data: { permission: Permission.LIST_DISTRIBUTOR },
    component: TestSendNewsletterEmailComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DistributorRoutingModule {}
